import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import styles from '../styles/configuration.module.scss';
import { Dropdown } from 'react-dropdown-now';
import 'react-dropdown-now/style.css';

function InputComponent({ label, initial, free, usable, setSpace, checkBox, options, available, style }) {
    const { t } = useTranslation('configuration');

    const units = ['GiB', 'TiB'];
    const multiplier = {
        GiB: 1,
        TiB: 1000
    };
    const actions = {
        '': () => ({
            s3: 0,
            fs: 0
        }),
        s3: (value) => ({
            s3: value,
            fs: 0
        }),
        fs: (value) => ({
            s3: 0,
            fs: value
        })
    };
    const freeSpace = usable * free / 100;
    const [checked, setChecked] = useState(!checkBox);
    const [currentUnit, setCurrentUnit] = useState(units[1]);
    const [value, setValue] = useState(initial);
    const [size, setSize] = useState(0);
    const [select, setSelect] = useState(options ? options[0].value : null);

    useEffect(() => {
        if (!checked) {
            setValue(0);
            setSize(0);
        }
    }, [checked]);

    useEffect(() => {
        const newSize = usable * value / (100 * multiplier[currentUnit]);
        setSize(parseFloat(newSize).toFixed(newSize > 1 ? 1 : 2));
    }, [currentUnit, usable]);

    useEffect(() => {
        initial === 0 && setValue(initial);
        initial === 0 && setSize(initial);
    }, [initial]);

    useEffect(() => {
        if (options) {
            if (select === options[0].value) {
                setSpace(actions[select]());
                setValue(0);
                setSize(0);
            } else {
                setSpace(actions[select](value));
            }
        }
    }, [select]);

    const checkMaxSize = (size) => {
        if (multiplier[currentUnit] * size <= freeSpace) {
            return size;
        }
        const newSize = freeSpace / multiplier[currentUnit]
        return parseFloat(newSize).toFixed(newSize > 1 ? 1 : 2);
    };

    const checkMaxPercent = (percent) => percent > free ? free : percent;

    const changeSize = (newSize) => {
        const numberSize = Number(newSize || 0);
        if (!isNaN(numberSize)) {
            const validSize = checkMaxSize(numberSize);
            setSize(validSize);
            setValue(checkMaxPercent(Math.floor(multiplier[currentUnit] * validSize * 100 / usable)));
        }
    };

    const changePercent = (percent) => {
        const validPercent = checkMaxPercent(Number(percent));
        const newSize = usable * validPercent / (100 * multiplier[currentUnit]);
        setValue(validPercent);
        setSize(parseFloat(newSize).toFixed(newSize > 1 ? 1 : 2));
    };

    const changeUnit = (newUnit) => {
        const newSize = usable * value / (100 * multiplier[newUnit]);
        setCurrentUnit(newUnit);
        setSize(parseFloat(newSize).toFixed(newSize > 1 ? 1 : 2));
    };

    useEffect(() => {
        setSpace(options ? actions[select](value) : value);
    }, [value]);

    return <div className={styles['custom-input']} style={style}>
        <label>
            { checkBox && <input type="checkbox"
                disabled={!available}
                readOnly
                className={available ? 'pointer ' : ''}
                checked={checked}
                style={{ marginLeft: '0px'}}
                onClick={(e) => {
                    e.stopPropagation();
                    setChecked(prevState => !prevState)}
                } /> }
            { label && <p className={checkBox && available ? 'pointer' : ''}>{t(label)}</p> }
        </label>
        {options &&
            <Dropdown
                disabled={!available || !checked}
                options={options.map((option) => ({ value: option.value, label: option.text }))}
                onChange={(e) => setSelect(e.value)}
                value={select}
                className={styles['dropdown-size']}
            />
        }
        <div className={styles.selectInline}>
            <input type='text'
                className={styles.percent}
                disabled={!available || !checked || (options && !select)}
                value={size}
                onChange={(e) => changeSize(e.target.value)}
                onFocus={(e) => e.target.select()} />
            <Dropdown
                disabled={!available || !checked || (options && !select)}
                options={units.map((unit) => ({ value: unit, label: t(unit.toLowerCase()) }))}
                onChange={e => changeUnit(e.value)}
                value={currentUnit}
                className={styles['dropdown-size']}
            />
        </div>
        <input type='range'
            className={(available && checked && !(options && !select) ? 'pointer ' : '') + styles.range}
            disabled={!available || !checked || (options && !select)}
            value={value || 0}
            min={0}
            max={100}
            style={{ background: '-webkit-linear-gradient(left ,#6934FF 0%, #6934FF ' + (value || 0) +'%, #D9D7E4 ' + (value || 0) + '%, #D9D7E4 100%)'}}
            onChange={(e) => changePercent(e.target.value)} />
        <p style={{ marginLeft: `calc(-5px + ${0.97 * (value || 0)}%)` }} className={styles['range-percent']}>{value}%</p>
    </div>
};

export default memo(InputComponent);
